module.exports = __webpack_public_path__ + "media/water.e557997f.mp4";